export const blogPosts = [
  {
    slug: "welcome-to-ai-hairstyle-studio",
    title: "Welcome to AI Hairstyle Studio",
    excerpt: "What we’re building, what’s changed after the Cloudflare move, and what you can expect next.",
    date: "2026-02-07",
    author: "AI Hairstyle Studio",
    content: `
We’ve moved the app off Google/Firebase and onto Cloudflare, and that’s a big stability win.

In this post we’ll cover:
- what changed (hosting, auth, APIs)
- what’s live today
- what’s coming next

Stay tuned — we’ll keep shipping improvements weekly.
`.trim()
  },
  {
    slug: "how-to-get-better-ai-hairstyle-results",
    title: "How to Get Better AI Hairstyle Results",
    excerpt: "A few small tweaks that dramatically improve realism and consistency.",
    date: "2026-02-07",
    author: "AI Hairstyle Studio",
    content: `
If results look “off”, it’s usually one of these:
1) lighting mismatch
2) low-res source photo
3) extreme head angle

Quick fixes:
- use bright, even lighting
- face camera straight on
- avoid strong shadows
`.trim()
  }
];
